import { addOrReplaceParameterLocationUtil } from 'modules/router/utils'
import { getApiServiceUrlEnvironmentUtil } from 'modules/environment/utils'
import { APP_OPTION } from 'constants/app'
import postApi from 'modules/api/services/post'
import putApi from 'modules/api/services/put'
import deleteApiService from 'modules/api/services/delete'

function saveReduxService (endpoint, data, options = {}) {
  const url = addOrReplaceParameterLocationUtil({
    path: `${getApiServiceUrlEnvironmentUtil()}${endpoint}`,
    ...options[APP_OPTION.JWT]
  })
  return postApi(url, data)
    .then(response => {
      return Object.values(response.data)[0]
    })
}

/**
 * Updates several instances with the given data.
 * @param  {string} endpoint
 * @param  {Object} data
 *         {string} className
 *         {Number[]} ids
 * @returns {Promise}
 */
function bulkSaveReduxService (endpoint, data) {
  const apiPath = `${getApiServiceUrlEnvironmentUtil()}${endpoint}`
  // Call the api
  return putApi(apiPath, data)
    .then(response => {
      const newInstances = response.data
      return newInstances
    })
}

/**
 * Deletes a data in the database.
 * @param  {string} endpoint
 * @param  {Object} data
 *         {number} id
 *         {string} className
 * @returns {Promise}
 */
function delReduxService (endpoint, data) {
  const apiPath = `${getApiServiceUrlEnvironmentUtil()}${endpoint}`
  // Call the api
  return deleteApiService(apiPath, data).then(() => null)
}

export {
  saveReduxService,
  bulkSaveReduxService,
  delReduxService
}
